import firebase from "firebase";

export async function updateComment(comment, delivery_id) {
  const { result, data } = (await firebase.functions()
    .httpsCallable("updateComment")({
      delivery_id: delivery_id,
      comment: comment,
    })).data;
  try {
    console.log(data);
    return result;
  } catch (err) {
    console.log(err);
    return [];
  }
}

export async function changeDeliveryStatus(state, id) {
  const { result, data } = (await firebase.functions()
    .httpsCallable("changeDeliveryStatus")({
      state: state,
      id: id,
    })).data;
  try {
    console.log(data);
    return result;
  } catch (err) {
    return false;
  }
}
